import script from "./title.vue?vue&type=script&setup=true&lang=ts"
export * from "./title.vue?vue&type=script&setup=true&lang=ts"

import "./title.vue?vue&type=style&index=0&id=09da9420&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09da9420"]])

export default __exports__